export default __webpack_public_path__ + "99741573c93811e7b9f2cf8629c16eb9.svg";